// import React, { useEffect, useState } from "react";
// import Box from "@mui/material/Box";
// import Grid from "@mui/material/Grid";
// import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
// import Button from "@mui/material/Button";

// import { useTranslation } from "react-i18next";

// import { useAuth } from "../../context/AuthContext";
// import AdminCheck from "./AdminCheck";
// import AdminAProduct from "./AdminAProduct";
// import { useProductContext } from "../../context/ProductContext";

// import { db, collection, query, doc, getDocs, setDoc } from "../../firebase";
// import AdminLeftMenu from "./AdminLeftMenu";

// const AdminDashboard = () => {
//   const { products2 } = useProductContext();
//   console.log(products2);
//   const { t, i18n } = useTranslation();
//   const [progress, setProgress] = useState(true);
//   const [err, setErr] = useState(null);
//   const [products, setProducts] = useState([]);
//   const [soldOut, setSoldOut] = useState(0);
//   const [stopped, setStopped] = useState(0);

//   useEffect(() => {
//     getOrders();
//   }, []);

//   const getOrders = async () => {
//     setProducts([]);
//     setSoldOut(0);
//     let ref = await collection(db, "products");
//     const q = query(ref);
//     const querySnapshot = await getDocs(q);
//     querySnapshot.forEach((doc) => {
//       if (+doc.data().quantity === 0) {
//         setSoldOut((old) => old + 1);
//       }
//       if (doc.data().stop === "true") {
//         setStopped((old) => old + 1);
//       }
//       setProducts((old) => old.concat({ ...doc.data(), id: doc.id }));
//     });
//   };
//   console.log("products", products);

//   useEffect(() => {
//     // console.log(stripUserId);
//     setTimeout(() => {
//       setProgress(false);
//     }, 500);
//   }, []);

//   return (
//     <Grid container>
//       <AdminCheck />
//       <AdminLeftMenu />
//       <Grid item md={9.5} sm={12}>
//         <Grid container>
//           <Grid
//             item
//             md={12}
//             sm={12}
//             xs={12}
//             sx={{ backgroundColor: "#faf9f6", minHeight: "100%" }}
//           >
//             <Box sx={{ py: 6, px: 3 }}>
//               {/* Content */}
//               <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
//                 <Box sx={{ fontSize: "16px" }}>상품 조회 수정</Box>
//                 {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
//                   View Details Stats
//                 </Box> */}
//               </Box>
//               <Box
//                 sx={{
//                   mt: 2,
//                   borderRadius: "2px",
//                   display: "flex",
//                   fontSize: "22px",
//                 }}
//               ></Box>
//               <Box
//                 sx={{
//                   backgroundColor: "white",
//                   my: 2,
//                   border: "1px solid lightgray",
//                   p: 2,
//                   display: "flex",
//                   justifyContent: "space-evenly",
//                 }}
//               >
//                 <Box>
//                   <FiberManualRecordIcon sx={{ fontSize: "11px", mr: 1 }} />
//                   전체 상품수: {products.length}개
//                 </Box>
//                 <Box>
//                   <FiberManualRecordIcon sx={{ fontSize: "11px", mr: 1 }} />
//                   품절: {soldOut}개
//                 </Box>
//                 <Box>
//                   <FiberManualRecordIcon sx={{ fontSize: "11px", mr: 1 }} />
//                   판매 중지: {stopped}개
//                 </Box>
//                 <Box>
//                   <FiberManualRecordIcon sx={{ fontSize: "11px", mr: 1 }} />
//                   판매중: {products.length - soldOut - stopped}개
//                 </Box>
//               </Box>

//               <Box
//                 sx={{
//                   py: 2,
//                   display: "flex",
//                   flexDirection: "row",

//                   flexWrap: "wrap",
//                   justifyContent: "space-around",
//                 }}
//               >
//                 {products.map((pro) => {
//                   return (
//                     <div key={pro.name}>
//                       <AdminAProduct currentCountry={"US"} pro={pro} />
//                     </div>
//                   );
//                 })}
//               </Box>
//             </Box>

//             {/* End of Content */}
//             {/* </Box> */}
//           </Grid>
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// };

// export default AdminDashboard;
// // users

import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import { useTranslation } from "react-i18next";

import AdminCheck from "./AdminCheck";
import AdminAProduct from "./AdminAProduct";
import { useProductContext } from "../../context/ProductContext";

import { db, collection, query, getDocs } from "../../firebase";
import AdminLeftMenu from "./AdminLeftMenu";

const AdminDashboard = () => {
  const { products } = useProductContext();
  console.log("proContext", products);
  const { t, i18n } = useTranslation();
  const [productsDB, setproductsDB] = useState([]);
  const [soldOut, setSoldOut] = useState(0);
  const [stopped, setStopped] = useState(0);

  useEffect(() => {
    getOrders();
  }, []);

  const getOrders = async () => {
    setproductsDB([]);
    setSoldOut(0);
    let ref = await collection(db, "products");
    const q = query(ref);
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      if (+doc.data().quantity === 0) {
        setSoldOut((old) => old + 1);
      }
      if (doc.data().stop === "true") {
        setStopped((old) => old + 1);
      }
      products.map((context) => {
        console.log(
          "context productId",
          context.productId,
          doc.id,
          context.productId.trim() === doc.id.trim()
        );
        if (doc.id.trim() === context.productId.trim()) {
          setproductsDB((old) =>
            old.concat({ ...doc.data(), id: doc.id, ...context })
          );
          console.log(
            doc.id + " " + context.productId,
            doc.id === context.productId
          );
        }
      });
      // setproductsDB((old) => old.concat({ ...doc.data(), id: doc.id }));
    });
  };
  // console.log("products", products);
  console.log("productsDB", productsDB);

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9.5} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6", minHeight: "100%" }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px" }}>상품 조회 수정</Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  View Details Stats
                </Box> */}
              </Box>
              <Box
                sx={{
                  mt: 2,
                  borderRadius: "2px",
                  display: "flex",
                  fontSize: "22px",
                }}
              ></Box>
              <Box
                sx={{
                  backgroundColor: "white",
                  my: 2,
                  border: "1px solid lightgray",
                  p: 2,
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <Box>
                  <FiberManualRecordIcon sx={{ fontSize: "11px", mr: 1 }} />
                  전체 상품수: {productsDB.length}개
                </Box>
                <Box>
                  <FiberManualRecordIcon sx={{ fontSize: "11px", mr: 1 }} />
                  품절: {soldOut}개
                </Box>
                <Box>
                  <FiberManualRecordIcon sx={{ fontSize: "11px", mr: 1 }} />
                  판매 중지: {stopped}개
                </Box>
                <Box>
                  <FiberManualRecordIcon sx={{ fontSize: "11px", mr: 1 }} />
                  판매중: {productsDB.length - soldOut - stopped}개
                </Box>
              </Box>

              <Box
                sx={{
                  py: 2,
                  display: "flex",
                  flexDirection: "row",

                  flexWrap: "wrap",
                  justifyContent: "space-around",
                }}
              >
                {productsDB.map((pro) => {
                  return (
                    <div key={pro.name}>
                      <AdminAProduct currentCountry={"US"} pro={pro} />
                    </div>
                  );
                })}
              </Box>
            </Box>

            {/* End of Content */}
            {/* </Box> */}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
// users
